import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

const rankColors: Record<string, string> = {
    'Brand New': '#666666', 'Newbie': '#888888', 'Jr. Member': '#22C55E',
    'Member': '#3B82F6', 'Full Member': '#8B5CF6', 'Sr. Member': '#F59E0B',
    'Hero Member': '#EF4444', 'Legendary': '#F7931A',
};

export default class MeritUserPage extends UserPage {
    loading: boolean = true;
    meritData: any = null;

    oninit(vnode: any) {
        super.oninit(vnode);
        this.loadUser(m.route.param('username'));
    }

    show(user: any) {
        super.show(user);
        this.loadMeritData(user.id());
    }

    async loadMeritData(userId: string) {
        this.loading = true;
        m.redraw();

        try {
            this.meritData = await app.request({
                method: 'GET',
                url: app.forum.attribute('apiUrl') + '/merit/user/' + userId,
            });
        } catch (e) {
            console.error('Failed to load merit data:', e);
        }

        this.loading = false;
        m.redraw();
    }

    content() {
        if (this.loading) {
            return <div className="MeritUserPage"><LoadingIndicator /></div>;
        }

        if (!this.meritData) {
            return <div className="MeritUserPage"><p>Failed to load merit data.</p></div>;
        }

        const data = this.meritData;
        const rank = data.meritRank || 'Brand New';
        const rankColor = rankColors[rank] || '#666666';

        return (
            <div className="MeritUserPage">
                <div className="merit-stats">
                    <div className="merit-stat">
                        <div className="merit-stat-value" style={'color: ' + rankColor}>{rank}</div>
                        <div className="merit-stat-label">{app.translator.trans('predictiontalk-merit-system.forum.profile.rank_label')}</div>
                    </div>
                    <div className="merit-stat">
                        <div className="merit-stat-value">{data.activity}</div>
                        <div className="merit-stat-label">{app.translator.trans('predictiontalk-merit-system.forum.profile.activity_label')}</div>
                    </div>
                    <div className="merit-stat">
                        <div className="merit-stat-value">{data.totalMeritReceived}</div>
                        <div className="merit-stat-label">{app.translator.trans('predictiontalk-merit-system.forum.profile.merit_received_label')}</div>
                    </div>
                    <div className="merit-stat">
                        <div className="merit-stat-value">{data.smeritBalance}</div>
                        <div className="merit-stat-label">{app.translator.trans('predictiontalk-merit-system.forum.profile.smerit_balance_label')}</div>
                    </div>
                </div>

                {/* Badges */}
                <h3>{app.translator.trans('predictiontalk-merit-system.forum.profile.badges_label')}</h3>
                {data.badges && data.badges.length > 0
                    ? <div className="merit-badges-list">
                        {data.badges.map((badge: any) => (
                            <span
                                className="merit-badge-tag"
                                style={'background-color: ' + badge.color}
                            >
                                {badge.icon && <i className={badge.icon} />}
                                {badge.name}
                            </span>
                        ))}
                    </div>
                    : <p className="helpText">{app.translator.trans('predictiontalk-merit-system.forum.profile.no_badges')}</p>
                }

                {/* Transaction History */}
                <h3>{app.translator.trans('predictiontalk-merit-system.forum.profile.transactions_label')}</h3>
                {data.transactions && data.transactions.length > 0
                    ? <table>
                        <thead>
                            <tr>
                                <th>{app.translator.trans('predictiontalk-merit-system.forum.dashboard.date')}</th>
                                <th>{app.translator.trans('predictiontalk-merit-system.forum.dashboard.type')}</th>
                                <th>{app.translator.trans('predictiontalk-merit-system.forum.dashboard.amount')}</th>
                                <th>{app.translator.trans('predictiontalk-merit-system.forum.dashboard.sender')}</th>
                                <th>{app.translator.trans('predictiontalk-merit-system.forum.dashboard.receiver')}</th>
                                <th>{app.translator.trans('predictiontalk-merit-system.forum.dashboard.reason')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.transactions.map((tx: any) => (
                                <tr>
                                    <td>{tx.createdAt ? new Date(tx.createdAt).toLocaleDateString() : '-'}</td>
                                    <td><span className={tx.type === 'merit' ? 'merit-count' : 'smerit-count'}>{tx.type}</span></td>
                                    <td>{tx.amount}</td>
                                    <td>{tx.sender?.username || '-'}</td>
                                    <td>{tx.receiver?.username || '-'}</td>
                                    <td>{tx.reason}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    : <p className="helpText">{app.translator.trans('predictiontalk-merit-system.forum.profile.no_transactions')}</p>
                }
            </div>
        );
    }
}
